module.exports = __webpack_public_path__ + "static/media/cheese.d6e3db42.jpeg";